module.exports = __webpack_public_path__ + "static/img/About-Us-Studio-Photo.a692c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/about/images/About-Us-Studio-Photo.jpg
// module id = eXtR
// module chunks = 1